import isArray from 'lodash/isArray';
import { SafeAnyType } from 'src/utils/safeAny';
import { isNotNull } from 'src/utils/types';

/** common function to check if there is correct data in modalData */
export const checkModalData = <T = string | string[]>(
  modalData: { type: string; data: SafeAnyType } | null,
  type: T
): modalData is { type: string; data: SafeAnyType } => {
  if (isNotNull(modalData)) {
    if (typeof type === 'string' && modalData.type === type) {
      return true;
    }
    if (isArray(type)) {
      return type.includes(modalData.type);
    }
  }
  return false;
};
